<!--模板界面-->
<template>
	<div class="nodeBody flexBetween">
		<ul class="nodeUl custom-scrollbar">
			<li v-for="item in dataList" :class="{isCheck:nowCheckNodeId == item.nodeId,isNowNode:item.nodeId == nowNodeId}"
			 @click="nodeClick(item)">{{item.nodeName}}<span>（{{item.nodeType == 0 ? '自定义' : item.nodeType==1 ? '现场交底' : item.nodeType==2 ? '巡检' : '审批'}}）</span></li>
		</ul>
		<ul class="itemUl custom-scrollbar">
			<!-- <li v-for="item in itemList" :class="{isCheck:nowCheckItemId == item.itemId}" @click="nowCheckItem(item)">{{item.title}}</li> -->
			<li v-for="item in itemList" :class="{isCheck:nowCheckItemId == item.itemId}" @click="nowCheckItem(item)">
				{{item.title}}
				
			</li>
			<li v-if="itemList.length == 0" style="text-align: center;">- 无操作项 -</li>
		</ul>
		<ul class="actionUl custom-scrollbar">
			<li v-for="items in nowArchiveDefectList" v-if="nowNodeType == 2">
				<!-- <p v-if="nowNodeType != 2" class="single-line" style="margin-bottom: 5px;" :title="item.content">{{item.actionName}}(类型:{{$store.enumStore.getters.getValueTypeNameByValueType(item.valueType)}}) : {{item.content}}</p> -->
				<div class="defectMessageBox" >
					<p class="defectTitle">{{ items.name }}</p>
					<p><span class="defectLabel">缺陷等级：</span>{{ priorityMatch[items.priority] }}</p>
					<p><span class="defectLabel">缺陷危害：</span>{{ items.harm }}</p>
					<p><span class="defectLabel">处理建议：</span>{{ items.proposal }}</p>
				</div>
			</li>
			<li v-for="item in otherItem" v-if="nowNodeType != 2 && itemList.length != 0">
				<!-- <p v-if="nowNodeType != 2" class="single-line" style="margin-bottom: 5px;" :title="item.content">{{item.actionName}}(类型:{{$store.enumStore.getters.getValueTypeNameByValueType(item.valueType)}}) : {{item.content}}</p> -->
				<div class="defectMessageBox" >
					<el-form >
					  <el-form-item label="操作步骤名称">
						  {{item.actionName}} 
					  </el-form-item>
					  <el-form-item label="操作步骤内容">{{item.content}}<span v-if="item.valueType == 'Boolean'">{{item.status ==0 ? '否' : '是'}}</span></el-form-item>
					</el-form>
				</div>
			</li>
		</ul>
		<!-- <ul class="actionUl custom-scrollbar">
			<li v-for="item in actionList" @click.stop="changeId[item.actionId] = true"> 
				<p v-if="nowNodeType != 2" class="single-line" style="margin-bottom: 5px;" :title="item.content">{{item.actionName}}(类型:{{$store.enumStore.getters.getValueTypeNameByValueType(item.valueType)}}) : {{item.content}}</p>
				<div class="defectMessageBox" v-if="nowNodeType == 2">
					<el-row v-show="item.status == null || item.status == 0">
					  <el-button type="primary" size="mini" @click="ignoreDefect(item)">忽 略</el-button>
					</el-row>
					<p class="defectTitle">{{ JSON.parse(item.content).name }}</p>
					<p>
						<span class="defectLabel">缺陷等级：</span>{{ priorityMatch[JSON.parse(item.content).priority] }}
					</p>
					<p>
						<span class="defectLabel">缺陷危害：</span>{{ JSON.parse(item.content).harm }}
					</p>
					<p>
						<span class="defectLabel">处理建议：</span>{{ JSON.parse(item.content).proposal }}
					</p>
				</div>
				<input type="text" v-if="item.valueType == 'Varchar'" v-model="uploadData[item.actionId]" :readonly="nowCheckNodeId != nowNodeId || !isMyNode || item.status == 2">
				<textarea v-else-if="item.valueType == 'Text'" cols="30" rows="10" v-model="uploadData[item.actionId]" placeholder="最大长度:1024字符"
				 maxlength="1024" :readonly="item.status == 2"></textarea>
				<input type="number" v-else-if="item.valueType == 'Int'" onkeyup="this.value=this.value.replace(/\D/g,'')"
				 onafterpaste="this.value=this.value.replace(/\D/g,'')" v-model="uploadData[item.actionId]" :readonly="item.status == 2">
				<input type="number" v-else-if="item.valueType == 'Float'" v-model="uploadData[item.actionId]" :readonly="item.status == 2">
				<input type="number" v-else-if="item.valueType == 'Long'" onkeyup="this.value=this.value.replace(/\D/g,'')"
				 onafterpaste="this.value=this.value.replace(/\D/g,'')" v-model="uploadData[item.actionId]" :readonly="item.status == 2">
				<datePicker v-else-if="item.valueType == 'Date'" dateType="date" :initDate="getInitDate(item.value)" @checkDate="changeId[item.actionId] = true,uploadData[item.actionId] = $event.getTime()"></datePicker>
				<datePicker v-else-if="item.valueType == 'DateTime'" dateType="dateTime" :initDate="getInitDate(item.value)"
				 @checkDate="changeId[item.actionId] = true,uploadData[item.actionId] = $event.getTime()"></datePicker>
				<booleanCheckBox v-else-if="item.valueType == 'Boolean'" :defaultValue="uploadData[item.actionId]" @checkItem="uploadData[item.actionId] = $event"></booleanCheckBox>
			</li>
		</ul> -->
	</div>
</template>

<script>
	import datePicker from '@/components/module/datePicker/base/datePicker.vue'
	import booleanCheckBox from '@/components/module/selection/base/booleanCheckBox.vue'
	export default {
		components: {
			datePicker,
			booleanCheckBox
		},
		props: {
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			nowNodeId: {
				type: Number,
			},
			isMyNode: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				nowCheckNodeId: undefined,
				nowCheckOrderId: undefined,
				nowCheckItemId: undefined,
				uploadData: {},
				changeId: {},
				nowArchiveDefectList: [],//设备消缺情况
				otherItem:[],//除巡检外的节点类型数据
			}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			priorityMatch() {
				return this.$store.orderGroupStore.state.priorityMatch
			},
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getBackgroudColorStyle() {
				return this.$store.resourcesStore.getters.getBackgroudColorStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			getColorById() {
				return this.$store.resourcesStore.getters.getColorById
			},
			getColorStyleById() {
				return this.$store.resourcesStore.getters.getColorStyleById
			},
			itemList() {
				var nowNode = this.dataList.find(item => {
					return item.nodeId == this.nowCheckNodeId
				})
				return getValueIfNoNull(nowNode, {
					next: []
				}).next
			},
			nowNodeType() {
				var nowNode = this.dataList.find(item => {
					return item.nodeId == this.nowCheckNodeId
				})
				return nowNode.nodeType
			},
			actionList() {
				var nowItem = this.itemList.find(item => {
					return item.itemId == this.nowCheckItemId
				})
				/* if(!isempty(nowItem) &&!isempty(nowItem.linkObject)){
					this.$api.workDefectApi.findDefectListByArchivesId(nowItem.linkObject, respon => {
					return respon[0].defectList
				})
				}else{
					return []
				} */
				return getValueIfNoNull(nowItem, {
					next: [] 
				}).next
			}
		},
		watch: {
			dataList(nv, ov) {
				//如果未选中节点则自动选中第一个
				if (this.nowCheckNodeId == undefined && !isempty(nv)) {
					this.nowCheckNodeId = nv[0].nodeId
					this.nowCheckOrderId = nv[0].orderId
					if (!isempty(nv[0].next)) {
						this.nowCheckItemId = nv[0].next[0].itemId
					}
				}
				//赋值，忽略已经修改的
				nv.forEach(node => {
					node.next.forEach(item => {
						item.next.forEach(action => {
							if (!this.changeId.hasOwnProperty(action.actionId)) {
								this.uploadData[action.actionId] = action.value
							}
						})
					})
				})
			},
			itemList(nv, ov) {
				if (nv.length == 0) {
					this.nowCheckItemId = undefined
					return
				}
				//如果旧的id不存在于新的列表，则需要重选
				var item = nv.find(item => {
					return item.itemId == this.nowCheckItemId
				})
				//自动获取第一个操作项数据
				this.nowCheckItem(nv[0])
				if (item == undefined) {
					this.nowCheckItemId = nv[0].itemId
				}
			}
		},
		methods: {
			nowCheckItem(item){
				if(isempty(item)){
					return
				}
				this.nowCheckItemId = item.itemId
				if(this.nowNodeType == 2){
					this.$api.workDefectApi.findDefectListByArchivesId(item.linkObject, respon => {
						this.nowArchiveDefectList = copy(respon[0].defectList)
					})
				}else if(this.nowNodeType != 2){
					if(isempty(item.next)){
						this.otherItem = {}
					}else{
						this.otherItem = copy(item.next)
					}
				}
			},
			getUploadData() {
				//获取所有的修改过的内容
				var data = {}
				eachObject(this.changeId, (itemValue, key) => {
					if (this.uploadData[key] != undefined) {
						data[key] = this.uploadData[key]
					}
				})
				// console.log("点击",data);
				return data
			},
			getInitDate(value) {
				if (value == undefined) {
					return undefined
				}
				return new Date(parseInt(value))
			},
			nodeClick(item) {
				log(item)
				this.nowCheckNodeId = item.nodeId
				this.nowCheckOrderId = item.orderId
			},
			// 忽略操作
			ignoreDefect(item) {
				this.$api.orderApi.ignoreCheckAction(this.nowCheckOrderId, item.actionId, respon => {
					this.$message(respon)
					this.$emit('updateOrderInfo')
				}, err => {
					this.$message({
						message: err,
						type: 'error'
					})
				})
			}
		}
	}
</script>

<style scoped>

	.nodeBody {
		overflow: hidden;
	}

	.nodeBody>ul {
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.nodeBody li {
		border: #C0C0C0 1px solid;
		border-width: 1px 0;
		padding: 10px 5px;
	}

	.itemUl li:hover,
	.nodeUl li:hover {
		background: #CCCCCC;
		color: white;
	}

	.itemUl>.isCheck,
	.nodeUl>.isCheck {
		background: #CCCCCC;
		color: white;
	}

	.nodeBody>.nodeUl>.isNowNode {
		background: #1890FF;
		color: white;
	}

	.nodeUl {
		width: 160px;
		border: #C0C0C0 1px solid;
		border-width: 0 1px 0 0;
	}

	.itemUl {
		width: 200px;
		border: #C0C0C0 1px solid;
		border-width: 0 1px 0 0;
	}

	.itemUl>li,
	.nodeUl>li {
		cursor: pointer;
	}

	.actionUl {
		width: calc(100% - 360px);
		min-height: 100%;
	}

	.actionUl p {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 95%;
	}

	.actionUl input,
	.actionUl textarea {
		width: 80%;
		resize: none;
	}
	
	
	.defectMessageBox {
		border: solid 1px #E4E4E4;
		border-radius: 2px;
		padding: 10px 15px;
		margin-bottom: 10px;
		position: relative;
	}
	
	.defectMessageBox>>>.el-row {
		position: absolute;
		top: 10px;
		right: 10px;
	}
	
	.defectMessageBox:hover {
		border-color: #0099FF;
	}
	
	.defectMessageBox>p {
		line-height: 28px;
	}
	
	.defectTitle {
		font-weight: bold;
	}
	
	.defectLabel {
		color: #CCCCCC;
		margin-left: 30px;
	}
	
	.defectLabel:first-child {
		margin: 0;
	}
</style>
